var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.4326 28.1853L19.295 14.8637L19.3106 14.8762L27.5495 5.32812H24.7963L18.0846 13.0996L12.7547 5.32812H5.53394L14.0648 17.7655L14.0638 17.7645L5.06641 28.1853H7.81965L15.2815 19.539L21.2119 28.1853H28.4326ZM11.6638 7.40605L24.4846 26.1073H22.3028L9.4716 7.40605H11.6638Z",
    fill: "#56565A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterDesktop);
export default __webpack_public_path__ + "static/media/Twitter-desktop.982fe730ce41ce067740d6743d050018.svg";
export { ForwardRef as ReactComponent };